import React from 'react'
import PageHeading from '../../../components/PageHeading'

export default function PlotDetail() {
    return (
        <div className='row pb-3'>
            <div className='col col-md-8'>
                <div className='container-fluid landformconatiner p-4' style={{ maxHeight: "420px" }}>
                    <div className='d-flex flex-column flex-md-row justify-content-between pe-3 ps-3 mb-2'>
                        <div className='d-flex flex-column'>
                            <PageHeading pagename="Project Summery" />
                            <small>Plot No 32</small>
                        </div>
                        <button className="btn btn-primary" type="button" class="btn btn-primary" >+ Project Portfolio</button>
                    </div>
                </div>
            </div>
            <div className='col col-md-4'>
                <div className='d-flex flex-column gap-3' >

                </div>
            </div>
        </div>
    )
}
